import { createFetchAction, createPromiseAction } from '../../utils';

export const devicesPsirtAction = {
  ...createFetchAction('devices-psirt'),
};

export const fetchDevicesPsirtAction = createPromiseAction(
  'devices-psirt/FETCH_DEVICES_PSIRT'
);
